import {
  SET_ERRORS,
  SET_SUCCESS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATEED,
  SET_EMPRESA,
} from "../types";
import api from "../../services/api";
import { getUserData } from "./userAction";
import JwtDecode from "jwt-decode";
import { setAuthorizatonHeader } from "../../utils/auth";

export const loginUser = (userData, history) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  api
    .post("/login", userData)
    .then((res) => {
      const { token, idEmpresa, nomeEmpresa, cnpj, razaoSocial } = res.data;
      const tokenDecote = JwtDecode(token);
      setAuthorizatonHeader(token, idEmpresa, nomeEmpresa, cnpj, razaoSocial);
      dispatch({ type: SET_EMPRESA, payload: tokenDecote.data[0]});
      dispatch(getUserData());
      dispatch({ type: CLEAR_ERRORS });
      history.push("/dashboard");
    })
    .catch((err) => {
      console.error("message", err.message);
      console.error("message", err);
      if (err.message === "Network Error") {
        dispatch({
          type: SET_ERRORS,
          payload: {
            geral: "Erro de conexão. Por favor, tente novamente mais tarde.",
          },
        });
      } else if (err.message === 'Request failed with status code 429') {
        dispatch({
          type: SET_ERRORS,
          payload: {
            geral: "Você chegou no limite de tentativa de login, aguarde alguns minutos",
          },
        });
      
      } else if (err.status === 500) {
        dispatch({
          type: SET_ERRORS,
          payload: {
            geral: "Erro de servidor. Por favor, tente novamente mais tarde.",
          },
        });
      } else {
        
        dispatch({
          type: SET_ERRORS,
          payload: {
            geral: " Usuário ou senha incorretos.",
          },
          
        });
      }
    });
};

export const recuperarLogin =  (email)  => (dispatch) => {
  dispatch({type: LOADING_UI});
  api.post('/esqueci-senha', {email})
  .then(res => {
    console.log(res.data)
    dispatch({type: CLEAR_ERRORS});
    dispatch({
      type: SET_SUCCESS,
      payload: true,
    })
    return true
  })
  .catch(err => {
    console.error('message', err.message)
    if(err.message === 'Network Error'){
      dispatch({
        type: SET_ERRORS,
        payload: { geral: "Erro de conexão. Por favor, tente novamente mais tarde." }
      })
    }else if(err.status === 500){
      dispatch({
        type: SET_ERRORS,
        payload: { geral: "Erro de servidor. Por favor, tente novamente mais tarde." }
      })
    }else{
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      })
    }
  })
}

export const salvarSenha =  (data, history)  => (dispatch) => {
  dispatch({type: LOADING_UI});
  console.log(data)
  api.post('/nova-senha', {...data})
  .then(res => {
    console.log(res.data)
    dispatch({type: CLEAR_ERRORS});
    dispatch({
      type: SET_SUCCESS,
      payload: true,
    })
    history.push('/login')
  })
  .catch(err => {
    console.error('message', err.message)
    if(err.message === 'Network Error'){
      dispatch({
        type: SET_ERRORS,
        payload: { geral: "Erro de conexão. Por favor, tente novamente mais tarde." }
      })
    }else if(err.status === 500){
      dispatch({
        type: SET_ERRORS,
        payload: { geral: "Erro de servidor. Por favor, tente novamente mais tarde." }
      })
    }else{
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      })
    }
  })
}

export const logoutUser = () => (dispatch) => {
  sessionStorage.removeItem("PhpontoIdToken");
  sessionStorage.removeItem("CompanyId");
  delete api.defaults.headers.Authorization;
  delete api.defaults.headers.CompanyId;
  dispatch({ type: SET_UNAUTHENTICATEED });
  window.location.href = "/login";
};

export const signupUser = (newUserData, history) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  api
    .post("/registro", newUserData)
    .then((res) => {
      const { token, idEmpresa } = res.data;
      const tokenDecote = JwtDecode(token);
      setAuthorizatonHeader(token, idEmpresa);
      dispatch({ type: SET_EMPRESA, payload: tokenDecote.data[0]});
      dispatch(getUserData());
      dispatch({ type: CLEAR_ERRORS });
      history.push("/dashboard");
    })
    .catch((err) => {
      console.error(err.message);
      if (err.message === "Network Error") {
        dispatch({
          type: SET_ERRORS,
          payload: {
            geral: "Erro de conexão. Por favor, tente novametne mais tarde.",
          },
        });
      } else if (err.status === 500) {
        dispatch({
          type: SET_ERRORS,
          payload: {
            geral: "Erro de servidor. Por favor, tente novametne mais tarde.",
          },
        });
      } else {
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data,
        });
      }
    });
};
